export default function ClearwaterComparisonSection() {
  return (
    <section id="comparison" className="py-16 md:py-20 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Your Options
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Fast Passport Center vs. the Miami Passport Agency
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Clearwater residents can choose between our private expedited service or the nearest
            regional passport agency in Miami. Here is how the two compare.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-[#1A365D] text-white">
                <th className="text-left px-5 py-4 font-semibold rounded-tl-lg">Feature</th>
                <th className="text-center px-5 py-4 font-semibold bg-[#F6C344] text-[#1A365D]">
                  Fast Passport Center
                </th>
                <th className="text-center px-5 py-4 font-semibold rounded-tr-lg">Miami Passport Agency</th>
              </tr>
            </thead>
            <tbody className="bg-white">
              {[
                { feature: "Processing Speed", us: "24–72 hours emergency", them: "Same-day to 2 weeks (by appointment)" },
                { feature: "Distance from Clearwater", us: "Fully online + mail", them: "~280 miles via I-75 (4.5+ hours)" },
                { feature: "Appointment Required", us: "No — start online anytime", them: "Yes — limited slots, hard to book" },
                { feature: "Travel to Facility", us: "None — we come to you", them: "Must drive or fly to Miami" },
                { feature: "Child Applications", us: "Guided acceptance support", them: "Both parents must appear" },
                { feature: "Photo Service", us: "Guidance + retake support", them: "Must bring compliant photos" },
                { feature: "Proof of Travel", us: "Flexible documentation help", them: "Strict proof required for appointment" },
                { feature: "Delivery", us: "FedEx/UPS to your Clearwater address", them: "Pick up in person or standard mail" },
                { feature: "Customer Support", us: "Phone & email throughout", them: "Limited during visit" },
                { feature: "Cost", us: "Service fee + government fees", them: "Government fees only + travel costs" },
              ].map((row, i) => (
                <tr key={i} className="border-b border-gray-100 last:border-0">
                  <td className="px-5 py-4 text-gray-700 font-medium">{row.feature}</td>
                  <td className="px-5 py-4 text-center text-[#1A365D] bg-[#F6C344]/5 font-medium">
                    {row.us}
                  </td>
                  <td className="px-5 py-4 text-center text-gray-600">{row.them}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8 grid md:grid-cols-2 gap-6">
          <div className="bg-white rounded-lg p-6 border border-gray-100">
            <h3 className="font-serif text-base font-bold text-[#1A365D] mb-3 flex items-center gap-2">
              <i className="ri-check-line text-[#F6C344]"></i>
              When Fast Passport Center Wins
            </h3>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-line text-[#F6C344] mt-0.5 shrink-0"></i>
                <span>You cannot take a full day to drive to Miami and back on I-75.</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-line text-[#F6C344] mt-0.5 shrink-0"></i>
                <span>You need guaranteed speed without gambling on limited agency appointments.</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-line text-[#F6C344] mt-0.5 shrink-0"></i>
                <span>You want expert guidance through forms, photos, and acceptance.</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-line text-[#F6C344] mt-0.5 shrink-0"></i>
                <span>You need a child passport and want help with parental consent complexities.</span>
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-lg p-6 border border-gray-100">
            <h3 className="font-serif text-base font-bold text-[#1A365D] mb-3 flex items-center gap-2">
              <i className="ri-check-line text-[#F6C344]"></i>
              When the Miami Agency Might Work
            </h3>
            <ul className="space-y-2 text-gray-600 text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-line text-[#F6C344] mt-0.5 shrink-0"></i>
                <span>You have confirmed travel within 14 days and can secure a hard-to-get appointment.</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-line text-[#F6C344] mt-0.5 shrink-0"></i>
                <span>You are already planning to be in the Miami area and can combine trips.</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-line text-[#F6C344] mt-0.5 shrink-0"></i>
                <span>You have a very simple renewal and want to avoid service fees.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}